import { useEffect, useState } from "react";
import API from "@/lib/api";
import { CheckCircle2, AlertCircle, Loader2, WifiOff } from "lucide-react";

const STATUS_CONFIG = {
  ok: { label: "Spruce connected", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", icon: CheckCircle2 },
  invalid_key: { label: "Spruce key invalid", bg: "bg-red-50", text: "text-red-700", border: "border-red-200", icon: AlertCircle },
  unreachable: { label: "Spruce unreachable", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", icon: WifiOff },
  unexpected: { label: "Spruce warning", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", icon: AlertCircle },
  not_configured: { label: "Spruce not configured", bg: "bg-muted", text: "text-muted-foreground", border: "border-border", icon: AlertCircle },
};

export default function SpruceHealthPill() {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("/spruce/health")
      .then(({ data }) => setHealth(data))
      .catch(() => setHealth({ status: "unreachable", message: "Couldn't check Spruce" }))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="inline-flex items-center gap-1.5 text-xs text-muted-foreground" data-testid="spruce-health-loading">
        <Loader2 className="w-3 h-3 animate-spin" /> Checking Spruce…
      </div>
    );
  }

  const config = STATUS_CONFIG[health?.status] || STATUS_CONFIG.unreachable;
  const Icon = config.icon;

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${config.bg} ${config.text} ${config.border}`}
      title={health?.message}
      data-testid={`spruce-health-pill-${health?.status || "unknown"}`}
    >
      <Icon className="w-3 h-3 shrink-0" />
      <span>{config.label}</span>
      {health?.http_code && health.status !== "ok" && (
        <span className="opacity-60">· {health.http_code}</span>
      )}
    </div>
  );
}
